import IconJBPerks from '../../../../../../assets/svg/icon-jb-perks.svg';
import React from 'react';
import { styles } from './PerksLandingHeader.css';

// TODO re-add the banner on a new branch

export const PerksLandingHeader = () => {
  return (
    <>
      <div className={styles.headingWrapper}>
        <div className={styles.perksLogoWrapper}>
          <IconJBPerks className={styles.perksLogo} />
        </div>
      </div>
      {/*<div className={styles.bannerContainer}>*/}
      {/*  <img src="https://i.imgur.com/9iZ2rvb.png" alt="banner" />*/}
      {/*</div>*/}
    </>
  );
};
